import * as React from 'react';
import classnames from 'classnames';
import { IMantleRichText, IMantleCtaButton } from '~domain/entities/Node';
import { MantleCtaButton } from './fields/MantleCtaButton';
import { MantleRichText } from './fields/MantleRichText';

interface IContentOver {
    layoutName: string;
    eyebrow: IMantleRichText;
    header: IMantleRichText;
    content: IMantleRichText;
    primaryCtaButton?: IMantleCtaButton;
    secondaryCtaButton?: IMantleCtaButton;
    findationCtaButton?: IMantleCtaButton;
    findationOnClick?(): void;
    textRow1: IMantleRichText;
    textRow2: IMantleRichText;
    horizontalAlignment: string;
    verticalAlignment: string;
    maxWidth: string;
    marginRight: string;
    marginLeft: string;
    marginTop: string;
    marginBottom: string;
    imageHideMobile: string;
    imageHidePc: string;
    textAlignment: string;
    hasImage: boolean;
}

export const ContentOver = (props: IContentOver) => {
    const {
        layoutName,
        eyebrow,
        header,
        content,
        primaryCtaButton,
        secondaryCtaButton,
        findationCtaButton,
        findationOnClick,
        textRow1,
        textRow2,
        horizontalAlignment,
        verticalAlignment,
        maxWidth,
        marginRight,
        marginLeft,
        marginTop,
        marginBottom,
        imageHideMobile,
        imageHidePc,
        textAlignment,
        hasImage
    } = props;

    const mediaBlockClassNames = classnames(
        `elc-${layoutName}__content-over-media-block`,
        `js-${layoutName}__content-over-media-block`,
        `${layoutName}__content-over-media`,
        'content-block__content',
        `${layoutName}__content-over-media-block`,
        hasImage && 'content-block__content-wrapper--positioned-stretched',
        horizontalAlignment ? horizontalAlignment : 'horizontal-align-left',
        verticalAlignment,
        imageHideMobile && 'mobile-flex-hidden',
        imageHidePc && 'pc-hidden'
    );

    const mediaWrapperClassNames = classnames(
        `elc-${layoutName}__content-over-media-wrapper`,
        `js-${layoutName}__content-over-media-wrapper`,
        'content-over-media__wrapper',
        `${layoutName}__content-over-media-wrapper`,
        maxWidth,
        marginRight,
        marginLeft,
        marginTop,
        marginBottom,
        textAlignment
    );

    const eyebrowClassNames = classnames(
        `elc-${layoutName}__eyebrow`,
        `js-${layoutName}__eyebrow`,
        'content-block__line',
        'content-block__line--eyebrow',
        `${layoutName}__eyebrow`
    );

    const headerClassNames = classnames(
        `elc-${layoutName}__header`,
        `js-${layoutName}__header`,
        'content-block__line',
        'content-block__line--header',
        `${layoutName}__header`
    );

    const linksWrapperClassNames = classnames(
        `elc-${layoutName}__links-wrapper`,
        `js-elc-${layoutName}__links-wrapper`,
        'content-block__links',
        `${layoutName}__links-wrapper`
    );

    const linkClassNames = classnames(
        `elc-${layoutName}__link`,
        `js-${layoutName}__link`,
        'content-block__line',
        'content-block__line--link',
        `${layoutName}__link`
    );

    const contentClassNames = classnames(
        `elc-${layoutName}__content`,
        `js-${layoutName}__content`,
        'content-block__line',
        'content-block__line--content',
        `${layoutName}__content`
    );

    const textRow1ClassNames = classnames(
        `elc-${layoutName}__text-row-1`,
        `js-${layoutName}__text-row-1`,
        'content-block__line',
        'content-block__line--text-row-1',
        `${layoutName}__text-row-1`
    );

    const textRow2ClassNames = classnames(
        `elc-${layoutName}__text-row-2`,
        `js-${layoutName}__text-row-2`,
        'content-block__line',
        'content-block__line--text-row-2',
        `${layoutName}__text-row-2`
    );

    const findationCtaWrapperClassNames = classnames(
        `elc-${layoutName}__findation-cta-wrapper`,
        `js-${layoutName}__findation-cta-wrapper`,
        'content-block__findation-cta',
        `${layoutName}__findation-cta-wrapper`
    );

    const findationCtaClassNames = classnames(
        `elc-${layoutName}-findation-cta`,
        `js-${layoutName}-findation-cta`,
        'content-block__line',
        'content-block__line--findation-cta',
        `${layoutName}__findation-cta`
    );

    const displayCtaButtons = primaryCtaButton?.text || secondaryCtaButton?.text;

    const displayOver =
        eyebrow.html ||
        header.html ||
        content.html ||
        displayCtaButtons ||
        findationCtaButton?.text;

    return displayOver ? (
        <div className={mediaBlockClassNames}>
            <div className={mediaWrapperClassNames}>
                <MantleRichText {...eyebrow} className={eyebrowClassNames} />
                <MantleRichText {...header} className={headerClassNames} />
                <MantleRichText {...content} className={contentClassNames} />
                {displayCtaButtons && (
                    <div className={linksWrapperClassNames}>
                        {primaryCtaButton && (
                            <MantleCtaButton {...primaryCtaButton} className={linkClassNames} />
                        )}
                        {secondaryCtaButton && (
                            <MantleCtaButton {...secondaryCtaButton} className={linkClassNames} />
                        )}
                    </div>
                )}
                {findationCtaButton?.text && (
                    <div className={findationCtaWrapperClassNames}>
                        <MantleCtaButton
                            {...findationCtaButton}
                            className={findationCtaClassNames}
                            onClick={findationOnClick}
                        />
                    </div>
                )}
                <MantleRichText {...textRow1} className={textRow1ClassNames} />
                <MantleRichText {...textRow2} className={textRow2ClassNames} />
            </div>
        </div>
    ) : null;
};
